function bodyFixPosition() {
    if (!document.body.hasAttribute('data-body-scroll-fix')) {
        let scrollPosition = window.scrollY || document.documentElement.scrollTop;

        document.body.setAttribute('data-body-scroll-fix', +scrollPosition);

        document.body.style.paddingRight = `${window.innerWidth - document.body.clientWidth}px`;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + scrollPosition + 'px';
        document.body.style.left = '0';
        document.body.style.width = '100%';
    }
}

function bodyUnfixPosition() {
    if (document.body.hasAttribute('data-body-scroll-fix')) {
        let scrollPosition = document.body.getAttribute('data-body-scroll-fix');

        document.body.removeAttribute('data-body-scroll-fix');

        document.body.style.paddingRight = '';
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.width = '';

        window.scroll(0, +scrollPosition);
    }
}

function pluralize(count, words) {
    const cases = [2, 0, 1, 1, 1, 2];
    return words[ (count % 100 > 4 && count % 100 < 20) ? 2 : cases[ Math.min(count % 10, 5)] ];
}

function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options = {}) {

    options = {
        path: '/',
        ...options,
        expires: new Date('12-12-2030'),
    };

    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }

    document.cookie = updatedCookie;
}

function deleteCookie(name) {
    setCookie(name, "", {
        'max-age': -1
    })
}

function resetForm(form) {
    const files = form.querySelector('.js-form-files-list');
    const submitBtn = form.querySelector('[type="submit"]');

    files && (files.innerHTML = '');
    submitBtn && (submitBtn.setAttribute('disabled', ''));
    form.reset();
}

function addClass(selector, classname) {
    const element = document.querySelector(selector);

    element && element.classList.add(classname);
}

function removeClass(selector, classname) {
    const element = document.querySelector(selector);

    element && element.classList.remove(classname);
}

function documentPreloaderStart() {
    bodyFixPosition();
    document.body.classList.add('_loading');
}

function documentPreloaderEnd() {
    document.body.classList.remove('_loading');
    bodyUnfixPosition();
}

function fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;

    textArea.style.bottom = '0';
    textArea.style.right = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    let success = false;

    try {
        const copyRes = document.execCommand('copy');

        let copyMsg = 'неуспешно';

        if (copyRes) {
            success = true;
            copyMsg = 'успешно';
        }

        console.log('Копирование значения ' + copyMsg);
    } catch (err) {
        console.error('Копирование завершено с ошибкой: ', err);
    }

    document.body.removeChild(textArea);

    return success;
}

function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        return fallbackCopyTextToClipboard(text);
    }

    navigator.clipboard.writeText(text).then(() => {
        console.log('Значение успешно скопировано');
        return true;
    }, (err) => {
        console.error('Ошибка при копировании: ', err);
        return false;
    })
}

function formatAmount(string) {
    return string.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

const checkResponse = response => response.ok ? response.json() : Promise.reject(response.status);

const request = (url, options) => fetch(url, options).then(checkResponse);

const hasClass = (element, selector) => {
    return (" " + element.className + " ").replace(/[\n\t]/g, " ").indexOf(" " + selector + " ") >= 0;
};

const addClassFunc = (_el, value) => {
    if (!_el) return;
    const classes = value.split(" ");
    const elements = (_el.length) ? _el : [_el];

    elements.forEach(element => {
        if (typeof element.classList === "undefined") return;
        classes.forEach(one => {
            if (one !== "" && !hasClass(element, one)) {
                element.classList.add(one);
            }
        });
    });
};

const removeClassFunc = (_el, value) => {
    if (!_el) return;
    const classes = value.split(" ");
    const elements = (_el.length) ? _el : [_el];

    elements.forEach(element => {
        if (typeof element.classList === "undefined") return;
        classes.forEach(one => {
            if (one !== "" && hasClass(element, one)) {
                element.classList.remove(one);
            }
        });
    });
};

const addCustomEventListener = function (selector, event, handler) {
    //since the root element is set to be body for our current dealings
    document.querySelector('body').addEventListener(event, function (evt) {
            let targetElement = evt.target;
            while (targetElement != null) {
                if (targetElement.matches(selector)) {
                    handler(evt);
                    return;
                }
                targetElement = targetElement.parentElement;
            }
        },
        true
    );
};

const fadeIn = function (elem, ms) {
    if (!elem) return;

    elem.style.opacity = 0;
    elem.style.filter = "alpha(opacity=0)";
    elem.style.display = "inline-block";
    elem.style.visibility = "visible";

    if (ms) {
        let opacity = 0;
        const timer = setInterval(function () {
            opacity += 50 / ms;
            if (opacity >= 1) {
                clearInterval(timer);
                opacity = 1;
            }
            elem.style.opacity = opacity;
            elem.style.filter = "alpha(opacity=" + opacity * 100 + ")";
        }, 50);
    } else {
        elem.style.opacity = 1;
        elem.style.filter = "alpha(opacity=1)";
    }
};

const fadeOut = function (elem, ms) {
    if (!elem) return;

    if (ms) {
        let opacity = 1;
        const timer = setInterval(function () {
            opacity -= 50 / ms;
            if (opacity <= 0) {
                clearInterval(timer);
                opacity = 0;
                elem.style.display = "none";
                elem.style.visibility = "hidden";
            }
            elem.style.opacity = opacity;
            elem.style.filter = "alpha(opacity=" + opacity * 100 + ")";
        }, 50);
    } else {
        elem.style.opacity = 0;
        elem.style.filter = "alpha(opacity=0)";
        elem.style.display = "none";
        elem.style.visibility = "hidden";
    }
};

const setTransformStyle = function (_el, transform) {
    if (_el) {
        _el.style["transform"] = transform;
        _el.style["webkitTransform"] = transform;
        _el.style["mozTransform"] = transform;
        _el.style["msTransform"] = transform;
    }
};

const isTouchDevice = function () {
    return 'ontouchstart' in window;
};

const getLocalPath = function () {
    const meta = document.querySelector('meta[name="template-path"]');
    return meta ? meta.getAttribute('content') : '';
};

const getMapStyles = function () {
    return [
        {"featureType": "water","elementType": "geometry.fill","stylers": [{"color": "#d3d3d3"}]},
        {"featureType": "transit","stylers": [{"color": "#808080"},{"visibility": "off"}]},
        {"featureType": "road.highway","elementType": "geometry.stroke","stylers": [{"visibility": "on"},{"color": "#b3b3b3"}]},
        {"featureType": "road.highway","elementType": "geometry.fill","stylers": [{"color": "#ffffff"}]},
        {"featureType": "road.local","elementType": "geometry.fill","stylers": [{"visibility": "on"},{"color": "#ffffff"},{"weight": 1.8}]},
        {"featureType": "road.local","elementType": "geometry.stroke","stylers": [{"color": "#d7d7d7"}]},
        {"featureType": "poi","elementType": "geometry.fill","stylers": [{"visibility": "on"},{"color": "#ebebeb"}]},
        {"featureType": "administrative","elementType": "geometry","stylers": [{"color": "#a7a7a7"}]},
        {"featureType": "road.arterial","elementType": "geometry.fill","stylers": [{"color": "#ffffff"}]},
        {"featureType": "road.arterial","elementType": "geometry.fill","stylers": [{"color": "#ffffff"}]},
        {"featureType": "landscape","elementType": "geometry.fill","stylers": [{"visibility": "on"},{"color": "#efefef"}]},
        {"featureType": "road","elementType": "labels.text.fill","stylers": [{"color": "#696969"}]},
        {"featureType": "administrative","elementType": "labels.text.fill","stylers": [{"visibility": "on"},{"color": "#737373"}]},
        {"featureType": "poi","elementType": "labels.icon","stylers": [{"visibility": "off"}]},
        {"featureType": "poi","elementType": "labels","stylers": [{"visibility": "off"}]},
        {"featureType": "road.arterial","elementType": "geometry.stroke","stylers": [{"color": "#d6d6d6"}]},
        {"featureType": "road","elementType": "labels.icon","stylers": [{"visibility": "off"}]},
        {"featureType": "poi","elementType": "geometry.fill","stylers": [{"color": "#dadada"}]}
    ];
};

const pauseDocScrollOnMap = (container) => {
    let zoomBtnIsPress = false;
    let mouseOverMap = false;

    if (!container) return;

    const unblockScrollbar = () => {
        window.kupApp.scrollBar.unblock(0);
    };

    const zoomKeyDown = (event) => {
        zoomBtnIsPress = event.metaKey || event.ctrlKey;
        if (zoomBtnIsPress) {
            console.log('Key is down');
        }
        if (zoomBtnIsPress && mouseOverMap && !window.kupApp.scroller.paused) {
            console.log('Key is down on map');
            window.kupApp.scroller.pause();
        }
    };

    const zoomKeyUp = (event) => {
        if (zoomBtnIsPress) {
            zoomBtnIsPress = event.metaKey || event.ctrlKey;
            console.log('Key is up');

            if (mouseOverMap && hasClass(document.body, 'is-locked')) {
                unblockScrollbar();
                console.log('Key is up and remove locked class');
            }
        }
    };

    document.addEventListener('keydown', zoomKeyDown);
    container.addEventListener('mouseenter', (event) => {
        event.stopPropagation();
        mouseOverMap = true;
        console.log('Mouse over the map');

        if (zoomBtnIsPress && !window.kupApp.scroller.paused) {
            console.log('Mouse over the map and the button is pressed');
            window.kupApp.scroller.pause();
        }

        document.addEventListener('keyup', zoomKeyUp);
    });
    container.addEventListener('mouseleave', (event) => {
        event.stopPropagation();
        mouseOverMap = false;
        console.log('Mouse left the map');

        if (window.kupApp.scroller.paused) {
            console.log('Mouse left the map and resume scroll');
            window.kupApp.scroller.resume();
        }

        if (hasClass(document.body, 'is-locked')) {
            unblockScrollbar();
        }
        document.removeEventListener('keyup', zoomKeyUp);
    });
    window.addEventListener('scroll', () => {
        if (zoomBtnIsPress && mouseOverMap && window.kupApp.scroller.paused) {
            window.kupApp.scrollBar.block(0);
        }
    });
};

const mapIsPartiallyInvisible = (map) => {
    const headerContainer = document.querySelector('.header');
    const mapBoundary = map.getBoundingClientRect();
    const scrollToMapPos = (mapBoundary.top + window.scrollY - headerContainer.clientHeight);
    const mapOverTop = mapBoundary.top + (mapBoundary.height / 3) < 0;
    const mapUnderBot = mapBoundary.top - window.innerHeight + (mapBoundary.height / 3) > 0;

    if (mapOverTop || mapUnderBot) {
        window.kupApp.scrollTo(scrollToMapPos);
    }
};

const getMaxHeight = (element) => {
    const _this = document.querySelector(element);
    const cssMaxHeight = window.getComputedStyle(_this).getPropertyValue('max-height');
    let maxHeightInPx;

    if (cssMaxHeight.search('%') === -1) {
        maxHeightInPx = cssMaxHeight;
    } else {
        // maxHeightInPx = (document.body.clientHeight / 100) * parseFloat(cssMaxHeight);
    }

    return parseInt(maxHeightInPx, 10);
};

const getMaxWidth = (element) => {
    const cssMaxWidth = window.getComputedStyle(element).getPropertyValue('max-width');
    let maxWidthInPx;

    if (cssMaxWidth.search('%') === -1) {
        maxWidthInPx = cssMaxWidth;
    } else {
        maxWidthInPx = (document.body.clientWidth / 100) * parseFloat(cssMaxWidth);
    }

    return parseInt(maxWidthInPx, 10);
};
